import PropTypes from 'prop-types'

import ShapeThumb from 'reactGarden/common/prop-types/ThumbContent'
import {
  ThumbTitle,
  ThumbAuthor
} from 'reactGarden/common/components/ThumbFragments'

import * as S from './styled'

const ThumbInfo = ({ data }) => (
  <S.ThumbnailInfo>
    <a href={data.url} title={data.title}>
      <ThumbTitle text={data.title} />
    </a>
    <ThumbAuthor date={data.publishDate} />
  </S.ThumbnailInfo>
)

ThumbInfo.propTypes = {
  data: PropTypes.shape({ ...ShapeThumb }).isRequired
}

export default ThumbInfo
